import { useEffect, useState } from 'react'

type TWindowSize = {
  width: number;
  height: number;
  isMobile: boolean;
}

type THook = TWindowSize

export const useWindowResize = (): THook => {
  const [windowSize, setWindowSize] = useState<TWindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth < 440,
  })

  useEffect(() => {
    const handleResize = (): void => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 440,
      });
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, []);

  return windowSize;
}
